import React from 'react';
import { CTAProps } from '../types';
import CTAPresentation from './CTAPresentation';

const CTAContainer: React.FC<CTAProps> = ({ 
  className, 
  id = 'cta' 
}) => {
  return (
    <CTAPresentation
      id={id}
    />
  );
};

export default CTAContainer;